import React from 'react';
import { Badge, type BadgeProps } from '@mantine/core';
import type { PostType } from './types';
import { postTypeBadgeColor, postTypeLabel } from './postTypeConstants';

export interface PostTypeBadgeProps extends Omit<BadgeProps, 'color' | 'children'> {
  type: PostType | number;
  /** When true, label is uppercased (detail hero). */
  uppercase?: boolean;
}

export function PostTypeBadge ({ type, uppercase = false, size = 'xs', ...rest }: PostTypeBadgeProps) {
  const label = postTypeLabel(type);
  return (
    <Badge size={size} color={postTypeBadgeColor(type)} {...rest}>
      {uppercase ? label.toUpperCase() : label}
    </Badge>
  );
}
